export default "__VITE_PUBLIC_ASSET__9edc7249__"